// @flow

import React from 'react';
import Wysiwyg from '../../../wysiwyg';
import type { ACFProps } from '../../../wysiwyg';
import { ElementContainer } from '../../../form';

type Props = {|
  ...ACFProps,
  className?: string,
  readMoreParts?: string,
|};

const WysiwygAtom = (props: Props) => (
  <ElementContainer>
    <Wysiwyg {...props} />
  </ElementContainer>
);

WysiwygAtom.defaultProps = {
  className: '',
  readMoreParts: '',
};

export default WysiwygAtom;
